import React, { useContext } from "react";
import bg from "../../assets/svgs/casebgsvg.svg";
import PrimaryButton from "../common/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const Data = () => {
  const navigate = useNavigate();
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={
        theme === "dark"
          ? "bg-white transition-all duration-500"
          : "bg-black text-white transition-all duration-500"
      }
    >
      <div className="max-w-screen-2xl mx-auto py-20 px-5 lg:px-20">
        <div
          className={`${
            theme === "dark" ? "bg-primary" : "bg-[#141414]"
          }  rounded-3xl flex justify-center items-center h-[400px] pt-20 relative transition-all duration-500`}
        >
          <div className="flex flex-col font-montserrat font-bold text-3xl lg:text-5xl text-white lg:text-center px-5 lg:px-0">
            <h4 className="mb-6 relative z-20 font-montserrat font-bold text-3xl lg:text-5xl  text-center">
            Let’s Make Your Brand the  <br />
            Next Success We Share
            </h4>
            <div
              onClick={() => navigate("/contact")}
              className="self-center lg:self-center relative z-20"
            >
              <PrimaryButton className={`${
                      theme === "dark"
                        ? "bg-white !text-black hover:!text-white hover:bg-secondary border !border-secondary hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                        : "border  border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                    } relative z-10 transition-all duration-500 py-3`}>
                Get in Touch
              </PrimaryButton>
            </div>
          </div>
          <img src={bg} className="absolute left-0 bottom-0 z-10" alt=""/>
        </div>
      </div>
    </div>
  );
};

export default Data;
